import {useState} from "react";
import ButtonsText from "../../../../../../../components/Button/ButtonText";
import CustomDialog from "../../../../../../../components/Dialog/DiaComp";
import {TextDrugDapsone} from "./TextDrugDapsone"


export default function Dapsone() {
    
    const [open, setOpen] = useState(false);
    const handleOpen = () => {setOpen(true);};
    const handleClose = () => {setOpen(false);};

return(
<>      
  
    <ButtonsText onClick={handleOpen} name='Dapsone' size='large' color='common.white'   />
    <CustomDialog open={open} onClose={handleClose}

        title="Dapsone - PGx Recommendation"
        content={ <TextDrugDapsone />}

        />

</>
)}